import AppButton from '../../../../../components/common/AppButton';
import {SVG} from '../../../../../constants/assetLists';
import {useOperationsContext} from '../../../../../context/OperationsContextProvider';

function AddButton() {
  const {setOpenAddEditAnnouncementDialog} = useOperationsContext();

  const handleAnnouncementDialogOpen = () => {
    setOpenAddEditAnnouncementDialog(true);
  };

  return (
    <AppButton
      variant="promoted"
      iconStart={
        <img
          src={SVG.addIcon}
          className="w-[12px] h-[12px] object-contain"
          alt="add"
        />
      }
      py="1rem"
      onClick={handleAnnouncementDialogOpen}>
      הוספה
    </AppButton>
  );
}

export default AddButton;
